<template>
    <div class="media--manager">
        <!-- tabs navegação -->
        <header-b-tab :sections="sections"/>
        <!-- opcoes de visualizacao -->
    </div>
</template>


<script>
import HeaderBTab from '../atoms/HeaderBTab.vue'

export default {
    name: "MediaManager",
    components: { HeaderBTab },
    props: {
        picsInGallery: {
			type: Array,
			required: false,
        },
        maxItemSelected: {
            required: false,
            type: Number,
        },
        // passar props "image-video" para o media manager ao instanciar para mostrar a tab vídeos
        type: {
            required: false,
            type: "image-only" | "image-video",
            default: "image-only",
        }
    },
    provide() {
        return {
            picsInGallery: this.picsInGallery,
            maxItemSelected: this.maxItemSelected
        }
    },
    data() {
        return {
            sections: [
                {id: 0, title: 'Imagens', content: 'image-manager', active: true, disabled: false},
                {id: 1, title: 'Videos', content: 'video-manager', active: false, disabled: this.type === "image-only"} ,
            ]
        }
    },
}
</script>

<style scoped>
    .media--manager {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 999999;
        background-color: white;
        overflow-y: scroll;
        overflow-x: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/components/organisms/MediaManager.vue